/**
 * The product mark, beside the title and in the browser tab.
 *
 * The same geometry as `public/favicon.svg`, deliberately duplicated rather than loaded
 * from that file: an `<img>` would be a second request and could not inherit the page's
 * colours, and inlining is a dozen lines. Change one, change the other - the comment in
 * the SVG says the same thing from the other side.
 */

interface BrandMarkProps {
  size?: number
  className?: string
  /**
   * An accessible name, when the mark is the only thing carrying it. Left unset - the
   * usual case - it is hidden from assistive technology instead, because it sits beside
   * a heading that already says the product's name and hearing it twice is noise.
   */
  label?: string
}

export function BrandMark({ size = 26, className, label }: BrandMarkProps) {
  return (
    <svg
      viewBox="0 0 32 32"
      width={size}
      height={size}
      className={className}
      {...(label ? { role: 'img', 'aria-label': label } : { 'aria-hidden': true })}
    >
      <defs>
        <linearGradient id="brandmark-tile" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#3987e5" />
          <stop offset="1" stopColor="#1f63b8" />
        </linearGradient>
      </defs>
      <rect width="32" height="32" rx="7" fill="url(#brandmark-tile)" />
      <path
        d="M4.5 17.5 H10 L13 10 L17.5 23 L20.5 15.5 H27.5"
        fill="none"
        stroke="#ffffff"
        strokeWidth="2.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
